import React from 'react';
import TooltipMenu from '@/elements/TooltipMenu';
import CreatedInfo from '@/elements/created-info';
import {
  EditIcon,
  MaximizeIcon,
  TrashIcon,
  DetailCode,
  CalendarTickIcon,
  LocationIcon,
  DescriptionIcon

} from 'assets/icon';
import CardTitle from '@/elements/card-title';
import { imgUrl } from 'utils/url';
import moment from 'moment';
import defaultLogo from '../../assets/default-logo.png';
import './EventCards.css';
import CardInfo from '@/elements/card-info';
import { ReactComponent as PoiIcon } from '../../assets/poi.svg';



const EventCards = ({
  data,
  dataAction,
  previewAction,
  editAction,
  deleteAction,
  cardClickAction,
  isClickable = false,
  isShowMedia = true,
  isPreview = true,
  isEdit = true,
  isDelete = true,
  isPreviewJSON = false,
  poiList,
  isDeals = false
}) => {
  // Handle both transformed and raw API data
  const displayName = data.title || 'Untitled';
  const displayLogo = data.eventDetails?.images?.[0]?.sourceUrl || data.featuredImage?.sourceUrl || '';
  const displayModifiedBy = data.modifiedBy || 'Unknown';
  const displayModifiedAt = data.modifiedAt || data.updatedAt || data.StartDate;
  const imageFolder = isDeals ? 'deals' : 'events';
  const eventImage = (
    <img
      src={displayLogo ? (data.modifiedBy=='Scape API' ? displayLogo : `${imgUrl}/${imageFolder}/${displayLogo}`) : defaultLogo}
      alt="default"
      className="card-event-img"
      draggable={false}
    />
  );
  // check location by merchant id
const getPoiName = (data, poiList) => {
  const matchedPoi = poiList && poiList.find(
    poi => String(poi.merchantId) === String(data.MerchantID)
  );

  return matchedPoi?.name || '';
};

  const eventDetailsSuntec = (
    <div className="card-event-details">
      <CardTitle title={displayName} />
      {data.Description &&
        <CardInfo
          icon={<DescriptionIcon style={{ width: 16, height: 16 }} />}
             title={
          data.Description &&
          (data.Description.length > 70
            ? `${data.Description.substr(0, 70)}...`
            : data.Description)
        }
        />
      }
      <CardInfo
        icon={<CalendarTickIcon style={{ width: 16, height: 16 }} />}
        title={(() => {
          if(data.schedulingType === 'list'){
            return data.schedulingIds.map(schedule => schedule.name).join(', ');
          }else{
            if (data.type === 'date' && data.start && data.end) {
              return `${moment(data.start).format('MMM, D YYYY')} - ${moment(data.end).format('MMM, D YYYY')}`;
            }
            if (data.type === 'date' && data.end) {
              return `Event will end on ${moment(data.end).format('MMM, D YYYY')}`
            }
            if (data.type === 'day' && data.days) {
              return `${data.days[0].day} - ${data.days[data.days.length - 1].day}`;
            }
            if (data.start && data.end) {
              return `${moment(data.start).format('MMM, D YYYY')} - ${moment(data.end).format('MMM, D YYYY')}`;
            }

            return 'All Day';
          }
        })()}

        />
        {data.MerchantID  &&
          <CardInfo
          icon={<LocationIcon style={{ width: 16, height: 16 }} />}
          title={
       getPoiName(data, poiList)
          }
        />
}
    </div>
  );
  const eventDetailsAdsign = (
    <div className="card-event-details">
      <CardTitle title={displayName} />
      {data.description &&
        <CardInfo
          icon={<DescriptionIcon style={{ width: 16, height: 16 }} />}
             title={
          data.description &&
          (data.description.length > 70
            ? `${data.description.substr(0, 70)}...`
            : data.description)
        }
        />
      }
      <CardInfo
        icon={<CalendarTickIcon style={{ width: 16, height: 16 }} />}
        title={(() => {
          if(data.schedulingType === 'list'){
            return data.schedulingIds.map(schedule => schedule.name).join(', ');
          }else{
            if (data.type === 'date' && data.start && data.end) {
              return `${moment(data.start).format('MMM, D YYYY')} - ${moment(data.end).format('MMM, D YYYY')}`;
            }
            if (data.type === 'day' && data.days) {
              return `${data.days[0].day} - ${data.days[data.days.length - 1].day}`;
            }
            if (data.start && data.end) {
              return `${moment(data.start).format('MMM, D YYYY')} - ${moment(data.end).format('MMM, D YYYY')}`;
            }

            return 'All Day';
          }
        })()}

        />
        {data.associatedPoi  &&
          <CardInfo
          icon={<LocationIcon style={{ width: 16, height: 16 }} />}
          title={
   ""
          }
        />
}
    </div>
  );


  return (
    <>
      <div
        className={data.source === 'scape-api' ? 'card-event-container ' : 'card-event-container adsign-card'}
        onClick={isClickable ? cardClickAction : () => {}}
      >
        {isShowMedia && eventImage}
        {data.source === 'scape-api' ? eventDetailsSuntec : eventDetailsAdsign }
      </div>
      {data.source === 'scape-api' ? (
        <div className="card-event-footer">
          <div className="card-event-footer-row">
            <div className="card-event-footer-column">
              <div className="created-by">
                <p>Last modified by:</p>
                <p>{displayModifiedBy}</p>
              </div>
              <div className="created-by">
                <p>Last modified at:</p>
                <p>{displayModifiedAt ? moment(displayModifiedAt).format('DD/MM/YYYY HH:mm') : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div
            className="card-event-footer-right"
            onClick={(e) => e.stopPropagation()}
          >
            <ul>
              {isEdit && (
                <li>
                  <TooltipMenu
                    title="Edit"
                    clickAction={editAction}
                    icon={<EditIcon style={{ width: 18, height: 18 }} />}
                  />
                </li>
              )}
              {isPreview && (
                <li>
                  <TooltipMenu
                    title="Preview"
                    clickAction={previewAction}
                    icon={<MaximizeIcon style={{ width: 18, height: 18 }} />}
                  />
                </li>
              )}
                {isPreviewJSON && (
                  <li>
              <TooltipMenu
                title="JSON"
                clickAction={dataAction}
             icon={<DetailCode style={{ width: 18, height: 18 }} />}
              />
            </li>
                )}

              {isDelete && (
                <li>
                  <TooltipMenu
                    title="Delete"
                    clickAction={deleteAction}
                    icon={<TrashIcon style={{ width: 18, height: 18 }} />}
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      ) : (
        <div className="card-event-footer adsign-footer">
          <div className="card-event-footer-left">
            <CreatedInfo user={displayModifiedBy} />
          </div>
          <div
            className="card-event-footer-right"
            onClick={(e) => e.stopPropagation()}
          >
            <ul>
              {isPreview && (
                <li>
                  <TooltipMenu
                    title="Preview"
                    clickAction={previewAction}
                    icon={<MaximizeIcon style={{ width: 18, height: 18 }} />}
                  />
                </li>
              )}
                {isEdit && (
                <li>
                  <TooltipMenu
                    title="Edit"
                    clickAction={editAction}
                    icon={<EditIcon style={{ width: 18, height: 18 }} />}
                  />
                </li>
              )}
               {isDelete && (
                <li>
                  <TooltipMenu
                    title="Delete"
                    clickAction={deleteAction}
                    icon={<TrashIcon style={{ width: 18, height: 18 }} />}
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default EventCards;